import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarService } from '@app/shared/services/sidebar.service';

@Injectable({ providedIn: 'root' })
export class EpanelSsoGuard {
  constructor(
    private sidebarService: SidebarService,
    private router: Router
  ) {}

  canActivate(): boolean {
    // 1. Fire your C# API encryption/tab launch script
    this.sidebarService.launchEpanelSSO();
    // 2. Break the routing loop and stay on the current screen safely
    return false;
  }
}
